import React, { Component } from 'react';

import ButtonCustom from '../../components/default/ButtonCustom'
import SwitchCustom from '../../components/default/SwitchCustom'
import ShowAvatar from '../../components/default/ShowAvatar'
import InputCustom from '../../components/default/InputCustom'

import { connect } from 'react-redux'
import { fetchAccount, updateNewStatus } from '../../actions/account'

class Account extends Component {
    state = {
        waiting: false
    }

    componentDidMount = () =>{
		this.props.fetchAccount()
    }

    onStatusChange = () => {
		const accountDetail = this
		this.setState({ waiting: true })
		setTimeout(() => {
			accountDetail.props.updateNewStatus()
			accountDetail.setState({ waiting: false })
		},800)
		
	}

    render() {
        if(Object.keys(this.props.account).length > 0){
            const { email, fullname, image, phone, status } = this.props.account;

            return (
                <div className="edit-profile-page-wrap">
                    <div className="account-page-title gapb-24">บัญชีผู้ใช้</div>
                    <div className="account-wrap gapb-16">
                        <div className="account-inner-wrap">
                            <div className="account-wrap-header is-row flex-between gapb-22">
                                <div className="account-wrap-title">{email}</div>
                                <div className="account-wrap-btn">
                                    <ButtonCustom
                                        className="edit-btn"
                                        borderRadius="4"
                                        color="outline-white"
                                        label="Edit"
                                        fontSize={12}
                                        href="/profile/edit" />
                                </div>
                            </div>
                            <div className="is-row flex-align-start is-sm-row">
                                <div className="account-image-wrap gapr-24 textAlign-center sm-gapb-16 is-sm-100">
                                    <ShowAvatar name={fullname} img={image} />
                                </div>
                                <div className="is-100">
                                    <div className="is-row gapb-16 is-100">
                                        <div className="account-detail-label is-20 is-sm-30">ชื่อ-สกุล:</div>
                                        <div className="is-100">
                                            <InputCustom
                                                value={fullname}
                                                size="large"
                                                type="text"
                                                disabled
                                                marginBottom="0" />
                                        </div>
                                    </div>
                                    <div className="is-row is-100">
                                        <div className="account-detail-label is-20 is-sm-30">โทรศัพท์:</div>
                                        <div className="is-100">
                                            <InputCustom
                                                value={phone}
                                                size="large"
                                                type="text"
                                                disabled
                                                marginBottom="0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="account-inner-wrap">
                            <ButtonCustom
                                borderRadius="4"
                                color="blue"
                                label="เปลี่ยนรหัสผ่าน"
                                fontSize={16}
                                fontWeight="large"
                                size="extra"
                                className="center"
                                href="/password/change"
                            />
                        </div>
                    </div>
                    <div className="account-wrap">
                        <div className="account-inner-wrap">
                            <div className="is-row flex-between">
                                <div className="account-detail-label">ติดตามข่าวสาร:</div>
                                <div>
                                    <SwitchCustom onClick={this.onStatusChange} loading={this.state.waiting} checked={status}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }else{
			return null
		}
    }
}

const mapStateToProps = (state) => {
	return {
		auth: state.auth,
		account: state.account
	}
}

const mapDispatchToProps = {
    fetchAccount,
    updateNewStatus
}

export default connect(mapStateToProps, mapDispatchToProps)(Account)
